<template>
  <div>
    <ul class="space-y-3">
      <li>
        <base-checkbox />
      </li>
      <li>
        <base-checkbox />
      </li>
    </ul>
    <!-- TODO add show logic to button below  -->
    <base-button class="mt-4" v-if="false">
      <svg
        class="mr-2"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 1V11M11 6L1 6"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
        />
      </svg>
      See More
    </base-button>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {
    "base-checkbox": () => import("@/components/utils/Checkbox.vue"),
    "base-button": () => import("@/components/utils/Button.vue"),
  },
};
</script>
